import { createSlice } from "@reduxjs/toolkit";
const userProfileSlice = createSlice({
  name: "userProfileSlice",
  initialState: {
    data: {
      fullName: "",
      isLogedin: false,
      userName: "",
      orgnisationName: "",
      phoneNumber: "",
      emailId: "",
      userType: "",
      country: "",
    },
  },
  reducers: {
    changeProfileStatus: (state, action) => {
      state.data = {
        isLogedin: action.payload.isLogedin,
        userName: action.payload.userName,
        orgnisationName: action.payload.orgnisationName,
        phoneNumber: action.payload.phoneNumber,
        emailId: action.payload.emailId,
        fullName: action.payload.fullName,
        userType: action.payload.userType,
        country: action.payload.country,
      };
    },
  },
});

export const { changeProfileStatus } = userProfileSlice.actions;
export default userProfileSlice.reducer;
